/**
 * Panel de Gobernanza de precios — reutiliza el panel de precios (REQ-MINT-013).
 *
 * Ruta: `/governance/model-pricing`. El formato es el panel de precios BA
 * (`PricingCatalogTable` + `GET /models/pricing`): solo ofertas con precio
 * cliente vigente, búsqueda/filtro/paginación en servidor y export auditado.
 * No usa la composición completa del catálogo ni pinta «Sin dato»/«Ficha vacía».
 */

import ModelPricingPage from './ModelPricingPage';

export default function ModelPricingGovernancePage() {
  return <ModelPricingPage showExport />;
}
